import axios from 'axios';
import { getCloudFunctionBase } from '@/config/deployment.js';
import SupportTicket from '../vo/SupportTicket.js';

let envBase = getCloudFunctionBase()
let supportTicketsUri = envBase + '/cf-hubspot-center/tickets'

export const submitSupportTicket=(supportRequest, reporterEmail)=>{
    return new Promise((resolve, reject) => {
        var validationReport = validateRequest(supportRequest);
        if(validationReport.success){
            let supportTicket = new SupportTicket(validationReport.result.subject, validationReport.result.content, reporterEmail, "Web App");
            var data = supportTicket;
            axios.post(supportTicketsUri, data)
                .then(res => { resolve("DONE") })
                .catch(err => { reject(err) })
        }else{
            reject(validationReport.errors)
        }
    })
}


function validateRequest(supportRequest){
    var errors = []
    if(!supportRequest.subject)errors.push("missing subject")
    if(!supportRequest.content)errors.push("missing content")
    return {success:errors.length==0, errors: errors, result:supportRequest}
}

// var invoiceNr = undefined
// var reporterEmail = undefined
// var userName = undefined
// var ticketRequest = {
//     subject: "Client has paid for invoice nr" + invoiceNr,
//     content: "User " + userName + " has claimed to have paid the invoice. Place check the payment status of this invoice."
// }
// submitSupportTicket(ticketRequest)


// WEBPACK FOOTER //
// ./src/platform/support/services/supportService.js